import { ReactNode } from 'react';

const H4 = ({ children }: { children: ReactNode }) => {
  return <h4 className="font_headline_xs_mobile md:font_headline_xs text-on_surface">{children}</h4>;
};

export default H4;
